module.exports = __webpack_public_path__ + "static/media/9DESA1.cf6da905.jpg";